(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title").click(function () {
			if (!$(this).hasClass("active")) {
				$(".product-about__accordion-title.active:not([data-no-close])").removeClass("active");
				$(this).addClass("active");
				$(".product-about__accordion-title:not([data-no-close])").siblings(".product-about__accordion-description").stop().slideUp(300);
				$(this)
					.siblings(".product-about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else if ($(this).attr("data-no-close") === undefined) {
				$(".product-about__accordion-title:not([data-no-close])").removeClass("active");
				$(".product-about__accordion-title:not([data-no-close])").siblings(".product-about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
